'use client';

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { HardHat, WifiOff, RefreshCw, Home } from "lucide-react";

export default function OfflinePage() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
      {/* Orange accent bar */}
      <div className="h-1 bg-primary fixed top-0 left-0 right-0" />
      
      <div className="max-w-md w-full text-center space-y-6">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary">
            <HardHat className="h-8 w-8 text-primary-foreground" />
          </div>
          <span className="text-2xl font-bold tracking-tight">RateRight</span>
        </div>

        {/* Offline Icon */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted">
          <WifiOff className="h-10 w-10 text-muted-foreground" />
        </div>

        {/* Title */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight">
            You're offline
          </h1>
          <p className="text-muted-foreground">
            It looks like you've lost your internet connection. Please check your connection and try again.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button 
            onClick={() => window.location.reload()} 
            className="gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            Try Again
          </Button>
          <Link href="/" className="sm:w-auto">
            <Button variant="outline" className="gap-2 w-full">
              <Home className="h-4 w-4" />
              Go Home
            </Button>
          </Link>
        </div>

        {/* Additional Info */}
        <div className="rounded-lg border bg-card p-4 text-sm text-muted-foreground">
          <p>
            RateRight works best with a stable internet connection. Some features may not be available while offline.
          </p>
        </div>
      </div>
    </div>
  );
}